import { InputContainer } from '@creditornot/cb-form';
import { Select } from '@creditornot/cb-select';
import { InboundLoadReferenceType } from 'common/api-types/warehouse';
import { FormField } from 'common/components/cookbook/FormField';
import { useFormatMessage } from 'common/hooks/useFormatMessage';

const referenceTypes: InboundLoadReferenceType[] = [
  'PURCHASE_ORDER',
  'WAYBILL',
  'ADVANCED_SHIPMENT_NOTIFICATION',
  'INVOICE',
  'VENDOR',
];

export const ReferenceTypeField = () => {
  const formatMessage = useFormatMessage();

  const referenceTypeOptions = referenceTypes.map((referenceType) => ({
    value: referenceType,
    label: formatMessage(`receiving.reference_type:${referenceType}`),
  }));

  return (
    <InputContainer label={formatMessage('receiving.reference_type')}>
      <FormField
        name="referenceType"
        rules={{ required: formatMessage('common.validation.required') }}
        renderInput={({ ref, ...fieldProps }) => (
          <Select<{ label: string; value: InboundLoadReferenceType }>
            placeholder={formatMessage('receiving.reference_type_placeholder')}
            options={referenceTypeOptions}
            inputId="referenceType"
            selectRef={ref}
            {...fieldProps}
          />
        )}
      />
    </InputContainer>
  );
};
